export default __webpack_public_path__ + "static/media/img6.efb467d0.jpg";